<div class="inscription-card">
  <div class="image-box">
    <ng-container >
      <img [src]="inscription.images[0]?.path ?? defaultImg | imageUrl" >
    </ng-container>
    <div class="category" *ngIf="inscription.categoryName">
      <span>{{ inscription.categoryName }}</span>
    </div>
  </div>
  <div class="info-box">
    <div class="event-title">
      <span class="line-clamp-2">{{ inscription.name }}</span>
    </div>
    @if (basePriceDisplayMode !== 'hidden') {
      <div class="price-line">
        @switch (basePriceDisplayMode) {
          @case ('free') {
            <span>{{ 'INSCRIPTIONS.BasePriceFreeLabel' | translate }}</span>
          }
          @case ('amount') {
            <span>{{ inscription.basePrice | appCurrencyPipe }}</span>
            @if (inscription.defaultRecurrence && inscription.defaultRecurrence !== 'OneTime') {
              <span class="recurrence"> / {{ ('INSCRIPTIONS.PAYMENT_RECURRENCES_AUX.' + inscription.defaultRecurrence) | translate | lowercase }}</span>
            }
          }
          @case ('from') {
            <span>{{ 'INSCRIPTIONS.BasePriceFromPrefix' | translate }} {{ inscription.basePrice | appCurrencyPipe }}</span>
            @if (inscription.defaultRecurrence && inscription.defaultRecurrence !== 'OneTime') {
              <span class="recurrence"> / {{ ('INSCRIPTIONS.PAYMENT_RECURRENCES_AUX.' + inscription.defaultRecurrence) | translate | lowercase }}</span>
            }
          }
        }
      </div>
    }
    <div class="data-box" *ngIf="false">
      <div class="when">
        <span>
            <i class="calendar-icon"></i> {{ dateFrom | localizedDate: "dd/MM/yyyy HH:mm" }} h
        </span>
      </div>
    </div>
  </div>
</div>
